var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.onBackdrop($event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c("h3", [_vm._v("Практическая часть обучения")]),
          _vm._v(" "),
          _vm.done
            ? [
                _c("p", [
                  _vm._v(
                    "Лист практики принят. Вы можете приступить к экзамену."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-modal",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("passed")
                      },
                    },
                  },
                  [_vm._v("\n        Перейти к экзамену\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-modal",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v("Закрыть")]
                ),
              ]
            : _vm.pepAllowed
            ? [
                _c("p", [
                  _vm._v("Уважаемый слушатель, Вы успешно завершили обучение."),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n        Пожалуйста, подпишите простой электронной подписью\n        "
                    ),
                    _vm.sheetUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "sheet-link",
                            attrs: { href: _vm.sheetUrl, target: "_blank" },
                          },
                          [_vm._v("«Лист практики»")]
                        )
                      : [_vm._v("«Лист практики»")],
                    _vm._v(".\n      "),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", { staticClass: "hint" }, [
                  _vm._v(
                    "Если не подпишете сейчас, лист практики останется доступен в разделе «Практика»."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-modal",
                    attrs: { type: "button", disabled: _vm.busy },
                    on: { click: _vm.sign },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.busy ? "Подписываем…" : "Подписать") +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline btn-modal",
                    attrs: { type: "button", disabled: _vm.busy },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v("Позже")]
                ),
                _vm._v(" "),
                _vm.error
                  ? _c("p", { staticClass: "error" }, [
                      _vm._v(_vm._s(_vm.error)),
                    ])
                  : _vm._e(),
              ]
            : [
                _c("p", [
                  _vm._v("Уважаемый слушатель, Вы успешно завершили обучение."),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("\n        Скачайте\n        "),
                    _vm.sheetUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "sheet-link",
                            attrs: { href: _vm.sheetUrl, target: "_blank" },
                          },
                          [_vm._v("«Лист практики»")]
                        )
                      : [_vm._v("«Лист практики»")],
                    _vm._v(
                      ",\n        подпишите его и загрузите скан или фотографию\n        подписанного листа — после этого откроется доступ к экзамену.\n      "
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", { staticClass: "hint" }, [
                  _vm._v(
                    "Если не загрузите сейчас, это можно сделать позже в разделе «Практика»."
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "upload" }, [
                  _c("input", {
                    ref: "file",
                    staticClass: "practice-file-input",
                    attrs: {
                      type: "file",
                      accept: ".pdf,.jpg,.jpeg,.png,.heic,.tif,.tiff,.bmp",
                    },
                    on: {
                      change: function ($event) {
                        _vm.error = ""
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-modal",
                    attrs: { type: "button", disabled: _vm.busy },
                    on: { click: _vm.upload },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.busy ? "Загружаем…" : "Отправить") +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline btn-modal",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v("Позже")]
                ),
                _vm._v(" "),
                _vm.error
                  ? _c("p", { staticClass: "error" }, [
                      _vm._v(_vm._s(_vm.error)),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }